export default __webpack_public_path__ + "f2d0b26aca541d0a02892c6cfa5c8c7e.png";